import { Phone, MessageCircle, Navigation, CalendarCheck, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/primitives";

const WA_LINK =
  "https://wa.me/919688996889?text=Hi%20V-Elite%20Drives%2C%20I%20would%20like%20to%20book%20a%20service%20appointment.";

export default function Contact({ onBook }) {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-walnut py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <Reveal>
          <Eyebrow index="10">Visit Us</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-2xl font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            Premium Automotive Care <span className="gold-text">Now in Tirupur.</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-10 lg:grid-cols-2">
          <Reveal delay={0.15}>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <MapPin size={18} className="mt-1 shrink-0 text-gold" />
                <div>
                  <div className="font-display text-sm font-bold uppercase tracking-[0.2em] text-ivory">
                    V-Elite Drives
                  </div>
                  <div className="mt-1 text-sm font-light leading-relaxed text-ivory/60">
                    295/2, Sundamedu, Vidyalayam,
                    <br />
                    Karuppa Gaundanpalayam,
                    <br />
                    Tiruppur, Tamil Nadu 641605
                  </div>
                </div>
              </div>
              <a
                href="tel:+919688996889"
                data-testid="contact-phone-display"
                className="gold-text block font-display text-3xl font-extrabold tracking-wide sm:text-4xl"
              >
                96889 96889
              </a>

              <div className="grid grid-cols-2 gap-3 pt-4">
                <a
                  href="tel:+919688996889"
                  data-testid="contact-call-button"
                  className="flex items-center justify-center gap-2 rounded-full bg-gradient-to-br from-gold-light to-gold-deep px-4 py-4 text-[11px] font-bold uppercase tracking-[0.18em] text-ink transition-transform duration-300 hover:scale-[1.03]"
                >
                  <Phone size={14} /> Call Now
                </a>
                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="contact-whatsapp-button"
                  className="flex items-center justify-center gap-2 rounded-full border border-gold/40 px-4 py-4 text-[11px] font-bold uppercase tracking-[0.18em] text-ivory transition-colors duration-300 hover:border-gold hover:text-gold"
                >
                  <MessageCircle size={14} className="text-gold" /> WhatsApp
                </a>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=295%2F2%2C%20Sundamedu%2C%20Vidyalayam%2C%20Karuppa%20Gaundanpalayam%2C%20Tiruppur%2C%20Tamil%20Nadu%20641605"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="contact-directions-button"
                  className="flex items-center justify-center gap-2 rounded-full border border-gold/40 px-4 py-4 text-[11px] font-bold uppercase tracking-[0.18em] text-ivory transition-colors duration-300 hover:border-gold hover:text-gold"
                >
                  <Navigation size={14} className="text-gold" /> Get Directions
                </a>
                <button
                  onClick={onBook}
                  data-testid="contact-book-button"
                  className="flex items-center justify-center gap-2 rounded-full border border-gold/40 px-4 py-4 text-[11px] font-bold uppercase tracking-[0.18em] text-ivory transition-colors duration-300 hover:border-gold hover:text-gold"
                >
                  <CalendarCheck size={14} className="text-gold" /> Book Service
                </button>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.25}>
            <div
              data-testid="contact-map"
              className="map-muted h-72 overflow-hidden rounded-2xl border border-gold/20 sm:h-80 lg:h-full lg:min-h-[360px]"
            >
              <iframe
                title="V-Elite Drives — Tirupur map"
                src="https://maps.google.com/maps?q=295%2F2%2C%20Sundamedu%2C%20Vidyalayam%2C%20Karuppa%20Gaundanpalayam%2C%20Tiruppur%2C%20Tamil%20Nadu%20641605&t=&z=15&ie=UTF8&iwloc=&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
